// API resources
import apiCollectiveArbitrations from '@/api/modules/collective-arbitrations'

// Mutations
import {
  RESET_MODULE,
  ADD_COLLECTIVE_ARBITRATION_LIST,
  ADD_COLLECTIVE_ARBITRATION_META,
  ADD_COLLECTIVE_ARBITRATION_AVAILABLE_LINES,
  ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_LIST,
  ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_META
} from '@/store/mutation-types'


// Default state
const getDefaultState = () => {
  return {
    list: [],
    meta: {},
    availableLines: [],
    availablePortfoliosList: [],
    availablePortfoliosMeta: {},
    filters: {}
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  fetchCollectiveArbitrations ({ commit }, payload = {}) {
    return apiCollectiveArbitrations.fetchCollectiveArbitrations(payload)
      .then(data => {
        commit(ADD_COLLECTIVE_ARBITRATION_LIST, data.collectiveArbitrations)
        commit(ADD_COLLECTIVE_ARBITRATION_META, data.meta || {})
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  fetchCollectiveArbitrationsAvailablePortfolios ({ commit }, payload = {}) {
    return apiCollectiveArbitrations.fetchCollectiveArbitrationsAvailablePortfolios(payload)
      .then(data => {
        commit(ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_LIST, data.portfolios)
        commit(ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_META, data.meta)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  fetchCollectiveArbitrationsAvailableLines ({ commit }, payload = {}) {
    return apiCollectiveArbitrations.fetchCollectiveArbitrationsAvailableLines(payload)
      .then(data => {
        commit(ADD_COLLECTIVE_ARBITRATION_AVAILABLE_LINES, data.availableLines)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_COLLECTIVE_ARBITRATION_LIST] (state, data) {
    state.list = data
  },

  [ADD_COLLECTIVE_ARBITRATION_META] (state, data) {
    state.meta = data
  },

  [ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_LIST] (state, data) {
    state.availablePortfoliosList = data
  },

  [ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_META] (state, data) {
    state.availablePortfoliosMeta = data
  },

  [ADD_COLLECTIVE_ARBITRATION_AVAILABLE_LINES] (state, data) {
    state.availableLines = data
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  getTotalAvailableLinesAmount: state => {
    let total = 0
    state.availableLines.map(fund => {
      return (total += fund.valuation)
    })
    return total
  }
}


export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
